export default __webpack_public_path__ + "static/media/torotting.d877db0f.png";